import { render, staticRenderFns } from "./EventStripePanel.vue?vue&type=template&id=585d2505&scoped=true"
import script from "./EventStripePanel.vue?vue&type=script&lang=js"
export * from "./EventStripePanel.vue?vue&type=script&lang=js"
import style0 from "./EventStripePanel.vue?vue&type=style&index=0&id=585d2505&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585d2505",
  null
  
)

export default component.exports